import React from 'react';

const PageTitleBooking = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large text-uppercase">Bokning</h1>
            </div>
        </div>
    );
};

export default PageTitleBooking;
